module.exports = {
      id: "googleplay-usage",
      viewBox: "0 0 108 32",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#googleplay",
      toString: function () {
        return this.url;
      }
    }